var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRequestinfo = function SvgRequestinfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "M5 18.334c0-6.25 0-9.374 1.592-11.565a8.3 8.3 0 0 1 1.843-1.843C10.625 3.334 13.75 3.334 20 3.334s9.374 0 11.565 1.592a8.3 8.3 0 0 1 1.843 1.843C35 8.96 35 12.084 35 18.334v3.333c0 6.25 0 9.375-1.592 11.565a8.3 8.3 0 0 1-1.843 1.844c-2.19 1.591-5.315 1.591-11.565 1.591s-9.374 0-11.565-1.591a8.3 8.3 0 0 1-1.843-1.844C5 31.042 5 27.917 5 21.667zM25.001 15.834H11.668m5 8.333h-5"
  })));
};
export default SvgRequestinfo;